import { GoogleLogin } from '@react-oauth/google';
import { useAuth } from '../hooks/useAuth';

export default function LoginPage() {
  const { handleGoogleSuccess } = useAuth();

  return (
    <div className="login-wrap">
      <div className="login-card">
        <div className="login-logo">The Belonging Co</div>
        <div className="login-tagline">Conference Management System</div>
        <div className="login-title">Sign In</div>
        <div className="login-sub">Use your TBCO Google account to access the system.</div>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 16 }}>
          <GoogleLogin
            onSuccess={handleGoogleSuccess}
            onError={() => console.error('Login failed')}
            theme="outline"
            size="large"
            text="signin_with"
            shape="rectangular"
          />
        </div>
      </div>
    </div>
  );
}
